import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import React__default from 'react';
import { api } from '@bilibili-maoer/web-utils';
import { Loading, ELoadingType } from '../../../../../loading/index.js';
import '../../../../../scrollable/legacy-scrollable/index.js';
import { Scrollable } from '../../../../../scrollable/scrollable/index.js';
import '../../../../../utils/fetcher.js';
import { prependPrefix } from '../../../../../utils/style.js';
import { getHistory } from '../../../api/history.js';
import { HISTORY_PAGE_URL } from '../../../url.js';
import { createUseThrottleRequest, createUseMomizedScroll } from '../../../utils.js';
import { FailedNotice } from './notice.js';

var useThrottleRequest = createUseThrottleRequest();
var useMomizedScroll = createUseMomizedScroll(); // TODO: gethistory 接口支持分页后，前端同步支持

var History = function History() {
  var _useThrottleRequest = useThrottleRequest({
    request: getHistory
  }),
      data = _useThrottleRequest.data,
      loading = _useThrottleRequest.loading,
      success = _useThrottleRequest.success;

  var _useMomizedScroll = useMomizedScroll(),
      scrollRef = _useMomizedScroll.scrollRef,
      updateScrollPos = _useMomizedScroll.updateScrollPos;

  var renderHistory = function renderHistory() {
    var _data$info, _context;

    if (loading) {
      return /*#__PURE__*/React__default.createElement(Loading, {
        className: "history-loading",
        type: ELoadingType.MGirl
      });
    }

    if (!success) {
      return /*#__PURE__*/React__default.createElement(FailedNotice, null);
    }

    if (!(data !== null && data !== void 0 && (_data$info = data.info) !== null && _data$info !== void 0 && _data$info.length)) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "history-empty"
      }, "\u8FD8\u6CA1\u6709\u64AD\u653E\u5386\u53F2\u5462~");
    }

    return _mapInstanceProperty(_context = data.info).call(_context, function (_ref) {
      var time = _ref.time,
          sound = _ref.sound;
      return /*#__PURE__*/React__default.createElement("ul", {
        className: "history-list-wrapper",
        key: time
      }, /*#__PURE__*/React__default.createElement("label", {
        className: "history-time"
      }, time), _mapInstanceProperty(sound).call(sound, function (_ref2) {
        var _context2;

        var id = _ref2.id,
            soundstr = _ref2.soundstr;
        return /*#__PURE__*/React__default.createElement("li", {
          className: "history-item",
          key: id
        }, /*#__PURE__*/React__default.createElement("a", {
          className: "history-item-link",
          target: "_player",
          href: _concatInstanceProperty(_context2 = "".concat(api.MISSEVAN_SITE_MAIN, "/sound/")).call(_context2, id),
          title: soundstr
        }, soundstr));
      }));
    });
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: prependPrefix('popup')
  }, /*#__PURE__*/React__default.createElement(Scrollable, {
    className: prependPrefix('history-scrollable'),
    onScroll: updateScrollPos,
    ref: scrollRef
  }, renderHistory()), /*#__PURE__*/React__default.createElement("a", {
    className: prependPrefix('more'),
    target: "_blank",
    href: HISTORY_PAGE_URL
  }, "\u67E5\u770B\u66F4\u591A"));
};

export { History };
